/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ReaderFragment } from 'relay-runtime';
export type Currency = "AUD" | "BGN" | "CAD" | "CHF" | "CLP" | "CNH" | "CNY" | "CZK" | "DKK" | "EUR" | "GBP" | "HKD" | "HUF" | "ISK" | "JPY" | "MXN" | "NOK" | "NZD" | "PLN" | "ROL" | "RON" | "RUB" | "SEK" | "SGD" | "USD" | "ZAR" | "%future added value";
export type FeeType = "ADE" | "ADF" | "ASB" | "AVH" | "BUF" | "CHI" | "CHIP" | "CHUP" | "CON" | "COR" | "CRDT" | "FXB" | "GST" | "INT" | "MGN" | "MSB" | "PLF" | "PLT" | "PRO" | "RTA" | "RTP" | "SIPP" | "STB" | "STBV" | "TAX" | "TRA" | "VHF" | "WDR" | "%future added value";
import type { FragmentReference } from "relay-runtime";
declare export opaque type ChargeInfoFormPane_viewer$ref: FragmentReference;
declare export opaque type ChargeInfoFormPane_viewer$fragmentType: ChargeInfoFormPane_viewer$ref;
export type ChargeInfoFormPane_viewer = {|
  +manualAccountCharges: ?{|
    +edges: $ReadOnlyArray<?{|
      +node: ?{|
        +accountchargePtr: {|
          +currency: Currency,
          +accountchargetenantportionSet: {|
            +edges: $ReadOnlyArray<?{|
              +node: ?{|
                +id: string,
                +quantity: number,
                +tenantAccount: ?{|
                  +id: string,
                  +name: ?string,
                  +accountPtr: {|
                    +id: string,
                    +name: ?string,
                  |},
                |},
              |}
            |}>
          |},
        |},
        +id: string,
        +amount: number,
        +description: ?string,
        +createdAt: any,
        +updatedAt: any,
        +feeType: FeeType,
        +currency: Currency,
        +account: {|
          +id: string,
          +name: ?string,
        |},
      |}
    |}>,
    +count: ?number,
  |},
  +$refType: ChargeInfoFormPane_viewer$ref,
|};
export type ChargeInfoFormPane_viewer$data = ChargeInfoFormPane_viewer;
export type ChargeInfoFormPane_viewer$key = {
  +$data?: ChargeInfoFormPane_viewer$data,
  +$fragmentRefs: ChargeInfoFormPane_viewer$ref,
};
*/


const node/*: ReaderFragment*/ = (function(){
var v0 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "currency",
  "args": null,
  "storageKey": null
},
v1 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "id",
  "args": null,
  "storageKey": null
},
v2 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "name",
  "args": null,
  "storageKey": null
},
v3 = [
  (v1/*: any*/),
  (v2/*: any*/)
];
return {
  "kind": "Fragment",
  "name": "ChargeInfoFormPane_viewer",
  "type": "Query",
  "metadata": null,
  "argumentDefinitions": [
    {
      "kind": "LocalArgument",
      "name": "chargeId",
      "type": "ID",
      "defaultValue": null
    }
  ],
  "selections": [
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "manualAccountCharges",
      "storageKey": null,
      "args": [
        {
          "kind": "Variable",
          "name": "id",
          "variableName": "chargeId"
        }
      ],
      "concreteType": "ManualAccountChargeNodeConnection",
      "plural": false,
      "selections": [
        {
          "kind": "LinkedField",
          "alias": null,
          "name": "edges",
          "storageKey": null,
          "args": null,
          "concreteType": "ManualAccountChargeNodeEdge",
          "plural": true,
          "selections": [
            {
              "kind": "LinkedField",
              "alias": null,
              "name": "node",
              "storageKey": null,
              "args": null,
              "concreteType": "ManualAccountChargeNode",
              "plural": false,
              "selections": [
                {
                  "kind": "LinkedField",
                  "alias": null,
                  "name": "accountchargePtr",
                  "storageKey": null,
                  "args": null,
                  "concreteType": "AccountChargeNode",
                  "plural": false,
                  "selections": [
                    (v0/*: any*/),
                    {
                      "kind": "LinkedField",
                      "alias": null,
                      "name": "accountchargetenantportionSet",
                      "storageKey": null,
                      "args": null,
                      "concreteType": "AccountChargeTenantPortionNodeConnection",
                      "plural": false,
                      "selections": [
                        {
                          "kind": "LinkedField",
                          "alias": null,
                          "name": "edges",
                          "storageKey": null,
                          "args": null,
                          "concreteType": "AccountChargeTenantPortionNodeEdge",
                          "plural": true,
                          "selections": [
                            {
                              "kind": "LinkedField",
                              "alias": null,
                              "name": "node",
                              "storageKey": null,
                              "args": null,
                              "concreteType": "AccountChargeTenantPortionNode",
                              "plural": false,
                              "selections": [
                                (v1/*: any*/),
                                {
                                  "kind": "ScalarField",
                                  "alias": null,
                                  "name": "quantity",
                                  "args": null,
                                  "storageKey": null
                                },
                                {
                                  "kind": "LinkedField",
                                  "alias": null,
                                  "name": "tenantAccount",
                                  "storageKey": null,
                                  "args": null,
                                  "concreteType": "TenantAccountNode",
                                  "plural": false,
                                  "selections": [
                                    (v1/*: any*/),
                                    (v2/*: any*/),
                                    {
                                      "kind": "LinkedField",
                                      "alias": null,
                                      "name": "accountPtr",
                                      "storageKey": null,
                                      "args": null,
                                      "concreteType": "AccountNode",
                                      "plural": false,
                                      "selections": (v3/*: any*/)
                                    }
                                  ]
                                }
                              ]
                            }
                          ]
                        }
                      ]
                    }
                  ]
                },
                (v1/*: any*/),
                {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "amount",
                  "args": null,
                  "storageKey": null
                },
                {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "description",
                  "args": null,
                  "storageKey": null
                },
                {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "createdAt",
                  "args": null,
                  "storageKey": null
                },
                {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "updatedAt",
                  "args": null,
                  "storageKey": null
                },
                {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "feeType",
                  "args": null,
                  "storageKey": null
                },
                (v0/*: any*/),
                {
                  "kind": "LinkedField",
                  "alias": null,
                  "name": "account",
                  "storageKey": null,
                  "args": null,
                  "concreteType": "AccountNode",
                  "plural": false,
                  "selections": (v3/*: any*/)
                }
              ]
            }
          ]
        },
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "count",
          "args": null,
          "storageKey": null
        }
      ]
    }
  ]
};
})();
// prettier-ignore
(node/*: any*/).hash = '634d56b48c2b7ce9959f54e135a39f63';
module.exports = node;
